import { merchantGroupSchema } from "./../../shared/merchantGroupSchema";
import { z } from "zod";
import {
  allowedPeriodSchema,
  categoryItemSchema,
  countryCodeSchema,
  typeLimitSchema,
} from "./_shared";

export const getRuleDataResponseSchema = z
  .object({
    company: z.uuid(),
    name: z.string(),
    onlyFrance: z.boolean(),
    nationalHolidays: z.boolean(),
    amountLimit: z.int(),
    typeLimit: typeLimitSchema,
    areOtherMerchantsAuthorized: z.boolean().optional(),
    areSupportingDocumentsMandatory: z.boolean(),
    unauthorizedMerchantGroups: z.array(merchantGroupSchema).optional(),
    allowedPeriods: z.array(allowedPeriodSchema),
    categories: z.array(categoryItemSchema),
    allowedCountries: z.array(countryCodeSchema),
    canPayOnline: z.boolean(),
  })
  .strict();

export type GetRuleDataResponse = z.infer<typeof getRuleDataResponseSchema>;
